import { Component, Input } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { MbConstants } from '../../../../shared/mb-constants'
import { AcademicDegree } from '../../../../models'

@Component({
  selector: 'mb-checkout-title-form-partial',
  templateUrl: './mb-checkout-title-form-partial.component.html',
})
export class MbCheckoutTitleFormPartialComponent {

  constants = MbConstants

  @Input() formGroup: UntypedFormGroup | undefined
  @Input() academicDegrees: AcademicDegree[] | undefined
  @Input() academicDegreeLabelKey: string = 'contact.title'
  @Input() selectedAcademicDegree: AcademicDegree = {
    code: this.constants.ACADEMIC_DEGREE,
    name: this.academicDegreeLabelKey
  }
  @Input() isFormDisabled: boolean | undefined

  onAcademicDegreeChange (value: AcademicDegree) {
    this.selectedAcademicDegree = value
    this.formGroup?.patchValue({ academicDegree: value })
  }
}

